export function consumeURLParams() {
  const FALSY_VALUES = new Set(["false", "null", "undefined", "", "0"]);

  const searchParams = new URLSearchParams(location.search);
  // Read only to strip it: old links still carry ?userID=, nothing uses it.
  const userID = searchParams.get("userID");
  const devMode = searchParams.get("devmode");
  let couponID = searchParams.get("couponID");
  const initialAvatarID = searchParams.get("initialAvatarID");

  if (couponID && FALSY_VALUES.has(couponID)) {
    couponID = null;
  }

  const hasConsumed = userID || devMode || couponID || initialAvatarID;
  if (hasConsumed) {
    const newUrl = new URL(location.href);
    if (userID) newUrl.searchParams.delete("userID");
    if (devMode) newUrl.searchParams.delete("devmode");
    if (couponID) newUrl.searchParams.delete("couponID");
    if (initialAvatarID) newUrl.searchParams.delete("initialAvatarID");
    window.history.replaceState({}, "", newUrl.toString());
  }

  return {
    devMode: devMode ? devMode === "true" : undefined,
    couponID,
    initialAvatarID,
  };
}
